import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/services/Screen-Shot-2022-06-07-at-5.21.07-PM.png")